interface Props {
  label: string;
  value: string;
}
const SavingsModalRow = ({ label, value }: Props) => {
  return (
    <div className="flex justify-between items-center text-gray-700">
      <span>{label}</span>
      <span className="font-medium capitalize">{value}</span>
    </div>
  );
};

export default SavingsModalRow;
